
   const menudata = [
        {
            day:"Monday",
            food:"Allfood",
            dish:"Beef",
            sauce:"Beans",
            sidedish:"Groundnuts", 
            extras:""
        },
        {
            day:"Tuesday",
            food:"Allfood",
            dish:"Chicken",
            sauce:"Beans",
            sidedish:"Groundnuts",
            extras:""

        },
        {
            day:"Wednesday",
            food:"Allfood",
            dish:"Goat",
            sauce:"Beans",
            sidedish:"Groundnuts",
            extras:""
        },
        {
            day:"Thursday",
            food:"Allfood",
            dish:"Fish",
            sauce:"Beans",
            sidedish:"Groundnuts",
            extras:""
        },
        {
            day:"Friday",
            food:"Allfood",
            dish:"Chicken",
            sauce:"Beans",
            sidedish:"Masala chips",
            extras:"Pilau Veg noodles plus garden salad",

        }
    ];
    


export default menudata;